import { render, staticRenderFns } from "./customerMessage.vue?vue&type=template&id=78879ea1"
import script from "./customerMessage.vue?vue&type=script&lang=js"
export * from "./customerMessage.vue?vue&type=script&lang=js"
import style0 from "./customerMessage.vue?vue&type=style&index=0&id=78879ea1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports